import CommonTable, {
  IActionData,
  ITableColumn,
} from '@/components/common/CommonTable';
import MainHeading from '@/components/common/MainHeading';
import PlusIcon from '@/components/Icons/PlusIcon';
import CardLayout from '@/components/Layout/CardLayout';
import Layout from '@/components/Layout/Layout';
import { RootState } from '@/redux/store';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import AddAssetsCategoryModal from './AddAssetsCategoryModal';
import EditIcon from '@/components/Icons/EditIcon';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import {
  getFilterUrl,
  orderByList,
  showToastNotification,
} from '@/utility/helper';
import { callApi, IApiErrorResponse } from '@/api/callApi';
import { IAssetCategoryResponse } from '@/interfaces/assets.model';
import { IDeleteResponse } from '@/interfaces/common.model';
import ViewIcon from '@/components/Icons/ViewIcon';
import { RoutesLink } from '@/utility/RouteLinks';
import FilterComponent from '@/components/common/FilterComponent';
import useFilter from '@/hooks/useFilter';
import { ITableRowData } from '@/interfaces/common.model';

export interface ITableData extends ITableRowData {
  name: string;
  id: string;
  description: string;
  index: number;
  toggleStatus: boolean | null;
}
interface IPageState {
  currentPage: number;
  totalPages: number;
  count: number;
  tableLoader: boolean;
  assetsCategory: ITableData[];
  filterData: string;
  searchQuery: string;
}
const AssetsCategory = () => {
  const navigate = useNavigate();
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const [editData, setEditData] = useState<ITableData | null>(null);
  const [pageStates, setPageStates] = useState<IPageState>({
    currentPage: 1,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    assetsCategory: [],
    filterData: '',
    searchQuery: '',
  });
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen);
  };
  const tableHeading: ITableColumn<ITableData>[] = [
    { value: 'index', label: '#' },
    { value: 'name', label: 'Name' },
    // { value: 'description', label: 'Description' },
    { value: 'toggleStatus', label: 'Status' },
  ];
  const ActionData: IActionData<ITableData>[] = [
    {
      label: 'View',
      className: 'btn btn-link ',
      icon: <ViewIcon />,
      title: 'view',
      clickHandler: (data: ITableData) => {
        navigate(RoutesLink?.assetCategoryDetail + `/${data?.id}`, {
          state: { data },
        });
      },
    },
    {
      label: 'Edit',
      className: 'btn btn-link',
      icon: <EditIcon />,
      title: 'edit',
      clickHandler: (data: ITableData) => {
        toggle();
        setEditData(data);
      },
    },
  ];
  useEffect(() => {
    getAssetsCategory();
  }, [
    filterDetails?.pageSize,
    pageStates?.currentPage,
    pageStates?.searchQuery,
    filterDetails?.department,
    filterDetails?.orderBy,
  ]);
  const getAssetsCategory = async () => {
    try {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: true,
      }));
      const filter = {
        search: pageStates.searchQuery,
        pageSize: filterDetails?.pageSize,
        pageNumber: pageStates.currentPage,
        departmentId: filterDetails?.department,
        orderBy: filterDetails?.orderBy,
      };
      const API = `${API_URL}${API_ENDPOINT?.getAssetsCategory}?${getFilterUrl(filter)}`;
      const response: IAssetCategoryResponse = await callApi(API, {
        method: 'GET',
      });
      if (response.status) {
        console.log(response);
        const newData: ITableData[] = response?.data?.assetCategory?.map(
          (item, index) => ({
            ...item,
            index: index + 1,
            toggleStatus: item?.status,
            id: item.id,
          }),
        );
        setPageStates((prev) => ({
          ...prev,
          assetsCategory: newData,
          tableLoader: false,
          totalPages: response?.data?.pageInfo?.totalPages,
          count: response?.data?.pageInfo?.total ?? 0,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
    }
  };
  const handleStatusToggle = async (data: ITableData, status: boolean) => {
    const postData = {
      name: data?.name,
      status: !status,
    };
    const updatedDepartment = pageStates?.assetsCategory.map((dep) => {
      if (dep?.id == data?.id) {
        return { ...dep, toggleStatus: !status, status: !status };
      }
      return dep;
    });
    setPageStates((prev) => ({ ...prev, assetsCategory: updatedDepartment }));
    try {
      const response: IDeleteResponse = await callApi(
        API_URL +
          API_ENDPOINT.addAssetsCategory +
          `?assetCategoryId=${data?.id}`,
        {
          method: 'POST',
          data: postData,
        },
      );
      if (response?.status) {
        showToastNotification('success', response?.message);
        // getDepartment();
      }
    } catch (error: unknown) {
      const updateCompanyList = pageStates.assetsCategory.map((dep) => {
        if (dep.id === data.id) {
          return {
            ...dep,
            toggleStatus: status,
          };
        }
        return dep;
      });
      setPageStates((prev) => ({ ...prev, assetsCategory: updateCompanyList }));
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    }
  };
  const {
    handleSearchChange,
    orderByHandler,
    pageChangeHandler,
    handleChangePageSize,
  } = useFilter(pageStates, setPageStates);
  return (
    <>
      <Layout>
        <div className="content">
          <MainHeading
            title={'Asset Categories'}
            buttonText={'Add Category'}
            buttonIcon={<PlusIcon />}
            clickHandler={toggle}

            // buttonLink={RoutesLink?.addLeaveSetting}
          />
          <CardLayout cardStyle="mb-4">
            <FilterComponent
              handleSearch={handleSearchChange}
              isGrid={false}
              orderByList={orderByList}
              orderByHandler={orderByHandler}
            />
            <CommonTable<ITableData>
              tableHeading={tableHeading}
              tableData={pageStates?.assetsCategory}
              ActionData={ActionData}
              count={pageStates?.count}
              pageSize={filterDetails?.pageSize}
              isLoading={pageStates?.tableLoader}
              currentPage={pageStates?.currentPage}
              totalPages={pageStates?.totalPages}
              handleStatusToggle={handleStatusToggle}
              pageChangeHandler={pageChangeHandler}
              handleChangePageSize={handleChangePageSize}
            />
          </CardLayout>
        </div>
      </Layout>
      <AddAssetsCategoryModal
        isOpen={isOpen}
        onClose={toggle}
        editData={editData}
        getAssetsCategory={getAssetsCategory}
      />
    </>
  );
};
export default AssetsCategory;
